import React from "react";
import ResourcePage from "@/components/ResourcePage";
import { Badge } from "@/components/Common";

export default function Branches() {
  return (
    <ResourcePage
      endpoint="/branches"
      testidPrefix="branch"
      eyebrow="Administration"
      title="Branch Management"
      subtitle="All Abrah Supermarket branches and locations."
      ctaLabel="Add branch"
      fields={[
        { name: "name", label: "Branch name", required: true },
        { name: "location", label: "Location" },
        { name: "phone", label: "Phone" },
        { name: "manager", label: "Branch manager" },
        { name: "manager_email", label: "Manager email (daily feedback digest)", type: "email",
          placeholder: "manager@example.com" },
      ]}
      columns={[
        { key: "name", label: "Branch" },
        { key: "location", label: "Location" },
        { key: "phone", label: "Phone" },
        { key: "manager", label: "Manager" },
        { key: "manager_email", label: "Digest email", render: (i) => i.manager_email
            ? <span className="text-emerald-800 text-xs font-medium">{i.manager_email}</span>
            : <span className="text-red-600 text-xs italic">Not set</span> },
        { key: "is_active", label: "Status", render: (i) => <Badge tone={i.is_active === false ? "gray" : "emerald"}>{i.is_active === false ? "Inactive" : "Active"}</Badge> },
      ]}
      searchKeys={["name", "location", "manager", "manager_email"]}
    />
  );
}
